<template>
  <a-modal v-model="visible" width="80%" @ok="handleOk" :footer="null">
    <div slot="title">{{ $t("quotation.设备询价单") }}</div>
    <div style="display: flex">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" style="flex: 1">
        <a-row>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('quotation.公司名称')"
              prop="companyName"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-input
                v-model="form.companyName"
                ref="companyName"
              /> </a-form-model-item
          ></a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('quotation.您的姓名')"
              prop="name"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-input v-model="form.name" /> </a-form-model-item
          ></a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('quotation.电子邮箱')"
              prop="email"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-input v-model="form.email" /> </a-form-model-item
          ></a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('quotation.联系电话')"
              prop="cellphone"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-input v-model="form.cellphone" /> </a-form-model-item
          ></a-col>
        </a-row>
        <a-form-model-item
          :label="$t('quotation.询问内容')"
          prop="desc"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 19 }"
        >
          <a-textarea
            :placeholder="$t('quotation.询问内容')"
            v-model="form.desc"
            :rows="6"
          />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 3 }">
          <a-button
            icon="check"
            type="primary"
            @click="onSubmit"
            style="width: 240px"
          >
            {{ $t("quotation.现在询问底价") }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <div
        v-if="this.isxunjian == ''"
        style="width: 320px; border-left: solid 1px #eee"
      >
        <div
          v-for="(item, index) in $store.state.xunjiaList"
          :key="index"
          style="display: flex; padding: 10px"
        >
          <img
            v-if="id == '1'"
            width="40%"
            height="auto"
            :src="item.pic ? item.pic : require('../img/wtupian.png')"
          />
          <img
            v-else
            width="40%"
            height="auto"
            :src="imgs[0] ? imgs[0] : require('../img/wtupian.png')"
          />
          <div style="padding: 0 0 0 10px">
            <div style="color: #0067b3">
              {{ item.code }} {{ item.model }} {{ item.brand }}
            </div>
            <div style="padding: 1rem 0; color: orangered">
              <a-button
                size="small"
                style="margin-left: 12px"
                @click="delImg(index)"
              >
                {{ $t("quotation.删除") }}</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import axios from "axios";
import { getBucket } from "../utils/util";
function randomString() {
  var len = len || 32;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
export default {
  components: {},

  data() {
    const checkEmail = (rules, value, callback) => {
      var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (re.test(value)) {
        callback();
      } else {
        callback("邮箱格式不正确");
      }
    };
    const checkPhone = (rules, value, callback) => {
      var re = /^1[3456789]\d{9}$/;
      if (re.test(value)) {
        callback();
      } else {
        callback("手机号码格式不正确");
      }
    };
    return {
      id: "1",
      imgs: [],
      arr: [],
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      isxunjian: "",
      form: {
        name: "",
        cellphone: "",
        email: "",
        companyName: "",
        desc: "",
        createTime: "",
      },
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司姓名", trigger: "blur" },
        ],
        email: [
          {
            required: true,
            message: "请填写你的电子邮箱，以便我们能给您发送报价邮件",
            trigger: "blur",
          },
          {
            required: true,
            validator: checkEmail,
            trigger: "blur",
          },
        ],
        cellphone: [
          {
            required: true,
            message: "请填写手机联系方式，以便我们能够及时取得联系",
            trigger: "blur",
          },
          {
            required: true,
            validator: checkPhone,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (localStorage.getItem("userJson") != {}) {
      // alert(Object.keys(this.$store.state.userInfo).length);
      // if (Object.keys(this.$store.state.userInfo).length != 0) {
      this.form = {
        name: this.$store.state.userInfo.name,
        userId: this.$store.state.userInfo.id,
        cellphone: this.$store.state.userInfo.cellphone,
        email: this.$store.state.userInfo.email,
        companyName: this.$store.state.userInfo.company,
      };
    } else {
      this.form = {
        name: "",
        userId: "",
        cellphone: "",
        email: "",
        companyName: "",
      };
    }
  },
  methods: {
    setTimes() {
      let year = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let month = mm < 10 ? "0" + mm : mm;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      this.form.createTime =
        year + "-" + month + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      //this.form.createTime = "2024-01-01 00:00:00";
    },
    async getImg(addr, id) {
      this.imgs = await getBucket(addr, id);
    },

    addQuotation() {
      this.setTimes();
      let arr = [];
      let arrxunjia = [];
      arrxunjia = this.$store.state.xunjiaList;
      arrxunjia.forEach((item) => {
        arr.unshift(item.code);
      });

      var records = {
        ...this.form,
        id: this.form.id,
        userId: this.form.userId,
        userName: this.form.name,
        createTime: this.form.createTime,
        assetJson: this.form.desc,
        userName: this.form.name,
        cellphone: this.form.cellphone,
        email: this.form.email,
        companyName: this.form.companyName,
      };
      var record = {
        id: randomString(),
        userId: records.userId,
        userName: records.name,
        createTime: records.createTime,
        articleList: arr.join(","),
        state: "1",
        stateMsg: "已询价",
        assetJson: this.form.desc,
        userName: records.name,
        cellphone: records.cellphone,
        email: records.email,
        companyName: records.companyName,
      };
      axios({
        url: this.$apiUrl + "/api/addRecord",
        method: "POST",
        data: { tableName: "jf_web_inquiryInfo", record },
        logRequired: false, // false为不存入日志
      }).then((res) => {
        if (res.data.errCode != "0") {
          this.$notification.error({
            message: "操作失败",
            description: "请求网络错误!",
          });
          return;
        }
        this.$notification.success({
          message: "操作成功",
          description: "询价成功!",
        });
        this.handleOk();
      });
    },
    onSubmit() {
      if (this.isxunjian == "") {
        this.$refs.ruleForm.validate((valid) => {
          //   alert(this.form.companyName);
          if (valid) {
            if (this.$store.state.xunjiaList.length > 0) {
              this.addQuotation();
            } else {
              this.$notification.error({
                message: "操作失败",
                description: "询价失败、请选择询价叉车!",
              });
              return false;
            }
          }
        });
      } else {
        this.$notification.error({
          message: "操作失败",
          description: "询价失败、请选择询价叉车!",
        });
      }
    },
    delImg(index) {
      let arr = [];
      arr = this.$store.state.xunjiaList;
      arr.splice(index, 1);
      this.$store.dispatch("setxunjiaMessage", arr);
      localStorage.setItem("xunjiaJson", JSON.stringify(arr));
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    show(e) {
      const { type, record, id } = e;
      if (type == "fork") {
        this.$store.dispatch("setxunjiaMessage", []);
        console.log(record);

        this.$store.state.xunjiaList.unshift(record);
      } else if (type == "bijiao") {
        this.$store.dispatch("setxunjiaMessage", []);
        let arr = [];
        arr = this.$store.state.bijiaoList;
        arr.forEach((item) => {
          this.$store.state.xunjiaList.unshift(item);
        });
      } else if (type == "shoucang") {
        this.$store.dispatch("setxunjiaMessage", []);
        let arr = [];
        arr = this.$store.state.favoriteList;
        arr.forEach((item) => {
          this.$store.state.xunjiaList.unshift(item);
        });
      } else if (type == "forkDetail") {
        this.id = id;
        this.$store.dispatch("setxunjiaMessage", []);
        this.$store.state.xunjiaList.unshift(record);
        this.getImg("basic/", id);
      } else {
        this.isxunjian = "1";
      }
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>

<style scoped></style>
